import React from 'react';

import styles from './TextLink.module.scss';

function TextLink(props: TextLinkProps) {
    
    return (
        <p
            className={styles.textlink}
            onClick={props.onClick}
        >
            {props.children}
        </p>
    );
}

class TextLinkProps {
    children?: React.ReactNode;
    onClick?: () => void;
}

export default TextLink;